import { createSelector } from 'reselect';

import {
  // Navigation
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationEventsSelector,
  navigationContentSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationBusinessSelector,
  // Features
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
} from '@xingternal/platform-layout-selectors';

const secondaryListSelector = createSelector(
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationEventsSelector,
  navigationContentSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationBusinessSelector,
  (
    isPremium,
    isProJobs,
    isProBusiness,
    premium,
    premiumUpsell,
    proJobs,
    proBusiness,
    events,
    content,
    groups,
    companies,
    business
  ) => {
    return {
      navigationItems: [
        isPremium ? premium : premiumUpsell,
        isProJobs && proJobs,
        isProBusiness && proBusiness,
        events,
        content,
        groups,
        companies,
        business,
      ].filter(Boolean),
    };
  }
);

export { secondaryListSelector };
